import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <h4>{{ 'survey.Corresponding survey has no responses' | translate }}</h4>
    `
})
export default class {}



// WEBPACK FOOTER //
// ./src/app/components/survey/public/report/noAnswer/index.js